import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
} from 'chart.js';
import { Bar, Pie } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
);

const TalentStats = ({ employees, matrixCategories }) => {
  const categories = matrixCategories.flat();
  const categoryData = categories.map(category => 
    employees.filter(emp => emp.category === category).length
  );

  const barChartData = {
    labels: categories,
    datasets: [
      {
        label: '人数',
        data: categoryData,
        backgroundColor: [
          '#FF6384',
          '#36A2EB',
          '#FFCE56',
          '#4BC0C0',
          '#9966FF',
          '#FF9F40',
          '#FF6384',
          '#36A2EB',
          '#FFCE56'
        ],
      },
    ],
  };

  const pieChartData = {
    labels: categories,
    datasets: [
      {
        data: categoryData,
        backgroundColor: [
          '#FF6384',
          '#36A2EB',
          '#FFCE56',
          '#4BC0C0',
          '#9966FF',
          '#FF9F40',
          '#FF6384',
          '#36A2EB',
          '#FFCE56'
        ],
      },
    ],
  };

  return (
    <div className="stats-charts">
      <div className="chart-container">
        <h3>人才分布柱状图</h3>
        <Bar
          data={barChartData}
          options={{
            responsive: true,
            plugins: {
              legend: {
                display: false,
              },
              title: {
                display: false,
              },
            },
          }}
        />
      </div>
      <div className="chart-container">
        <h3>人才分布饼图</h3>
        <Pie
          data={pieChartData}
          options={{
            responsive: true,
            plugins: {
              legend: {
                position: 'right',
              },
            },
          }}
        />
      </div>
    </div>
  );
};

export default TalentStats; 